import { languageItem } from '@/language/helpers';
import TermsModal from '@/modals/TermsModal.vue';
import { openModal } from '@/modals/helpers/api';
export function openTermsModal(onClose) {
    return new Promise(() => openModal({
        name: 'terms-conditions',
        component: TermsModal,
        title: languageItem('termsModal').title,
        onClose,
        describedBy: 'terms-and-conditions-content',
    }));
}
